import React from "react";
import { Modal } from "react-bootstrap";
import Loader from "Common/Loader";

interface PdfViewerModalProps {
    visible: boolean;
    base64Data: string | null;
    onClose: () => void;
    title?: string;
}

const PdfViewerModal: React.FC<PdfViewerModalProps> = ({ visible, base64Data, onClose, title }) => {
    const srcUrl = base64Data ? `data:application/pdf;base64,${base64Data}` : "";

    return (
        <Modal
            show={visible}
            onHide={onClose}
            size="xl"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {base64Data ? (
                    <iframe
                        title="PDF Viewer"
                        src={srcUrl}
                        style={{ width: "100%", height: "80vh", border: "none" }}
                    />
                ) : (
                    <Loader />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default PdfViewerModal;